import React from 'react';
import { motion } from 'framer-motion';
export function PersonalNote() {
  return <section className="w-full bg-gradient-to-b from-[#0a0a0a] via-[#14100c] to-[#0a0a0a] py-20 px-4 border-y border-[#D4AF37]/10" data-id="element-230">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.7
    }} className="max-w-2xl mx-auto flex flex-col items-center text-center" data-id="element-231">
        <div className="w-24 h-24 sm:w-32 sm:h-32 rounded-full overflow-hidden border-2 border-[#D4AF37]/40 mb-8 p-1" data-id="element-232">
          <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&q=80" alt="Ludmila Reyes" className="w-full h-full object-cover rounded-full" data-id="element-233" />
        </div>

        <p className="font-playfair text-xl sm:text-2xl text-gray-200 leading-relaxed italic mb-8" data-id="element-234">
          "Este trabajo es mi vocación y mi forma de vida. Hago cada pedido
          personalmente porque me importan tus resultados de verdad. Te prometo
          que va a valer cada minuto."
        </p>

        <div className="flex flex-col items-center" data-id="element-235">
          <h4 className="font-playfair text-2xl text-white mb-1" data-id="element-236">
            Ludmila Reyes 🌸
          </h4>
          <p className="font-inter text-[#D4AF37] text-sm uppercase tracking-widest" data-id="element-237">
            Sanadora Espiritual & Guía Energética
          </p>
        </div>
      </motion.div>
    </section>;
}